import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {getModel} from './data/Model'

class UploadingPhotosInfo extends Component {
	render() {
		return(
			<div className='uploading-photos-info'>
				<h3>{this.context.gettext('upload.images.header')}</h3>
				<p>{getModel().uploadPhotoQueue.length} tilbage</p>
				<img src={getModel().uploadPhotoQueue[0].file.preview} alt={getModel().uploadPhotoQueue[0].file.alt} />
			</div>
		)
	};
}

UploadingPhotosInfo.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default UploadingPhotosInfo
